import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ChartRenderer = ({ chartData }) => {
  try {
    // Parse JSON if it's a string
    const parsedData = typeof chartData === 'string' ? JSON.parse(chartData) : chartData;
    
    // Default options for interactive bar charts
    const defaultOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'top',
        },
        tooltip: {
          enabled: true,
          mode: 'index',
          intersect: false,
        },
      },
      scales: {
        x: {
          display: true,
        },
        y: {
          display: true,
          beginAtZero: true,
        },
      },
      interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false,
      },
    };

    // Merge user options with defaults
    const options = {
      ...defaultOptions,
      ...parsedData.options,
      plugins: {
        ...defaultOptions.plugins,
        ...parsedData.options?.plugins,
      },
    };

    // Ensure we have valid chart data
    if (!parsedData.data || !parsedData.data.labels || !parsedData.data.datasets) {
      throw new Error('Invalid chart data structure');
    }

    // Add default colors if not provided
    const processedData = {
      ...parsedData.data,
      datasets: parsedData.data.datasets.map((dataset, index) => ({
        backgroundColor: `rgba(${54 + index * 50}, ${162 - index * 20}, ${235 - index * 30}, 0.5)`,
        borderColor: `rgba(${54 + index * 50}, ${162 - index * 20}, ${235 - index * 30}, 1)`,
        borderWidth: 1,
        ...dataset,
      })),
    };

    return (
      <div className="chart-container" style={{ height: '400px', margin: '20px 0' }}>
        <Bar data={processedData} options={options} />
      </div>
    );
  } catch (error) {
    return (
      <div className="chart-error" style={{ 
        padding: '20px', 
        margin: '20px 0', 
        backgroundColor: '#fee', 
        border: '1px solid #fcc', 
        borderRadius: '4px',
        color: '#c33'
      }}>
        <strong>Chart Error:</strong> {error.message}
        <br />
        <small>Please check your chart JSON format.</small>
      </div>
    );
  }
};

export default ChartRenderer;
